var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kpi-stat-card",class:{
    'kpi-stat-card--highlight': _vm.highlight,
    'kpi-stat-card--alert': _vm.variant === 'alert'
  }},[_c('div',{staticClass:"kpi-stat-card__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"kpi-stat-card__value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),(_vm.sublabel)?_c('div',{staticClass:"kpi-stat-card__sublabel"},[_vm._v(" "+_vm._s(_vm.sublabel)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }